import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import api from "../lib/api";

export default function DreamNumber() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api
      .get("/dreams")
      .then((r) => setRows(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  const filtered = rows.filter((r) =>
    r.dream.toLowerCase().includes(q.trim().toLowerCase())
  );

  return (
    <PublicLayout title="Dream Number">
      <div className="nt-container mt-6">
        <div className="mb-3 flex items-center gap-2">
          <input
            data-testid="dream-search"
            placeholder="Search dream…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="w-full rounded-lg border-2 border-slate-300 px-3 py-2 focus:outline-none focus:border-emerald-500"
          />
        </div>

        <div className="overflow-x-auto">
          <table className="nt-table" data-testid="dream-table">
            <thead>
              <tr>
                <th colSpan={4} className="text-lg">DREAM MEANING</th>
              </tr>
              <tr>
                <th>DREAM</th>
                <th>DIRECT</th>
                <th>HOUSE</th>
                <th>ENDING</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="text-center py-6">Loading…</td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center py-6">No entries.</td>
                </tr>
              ) : (
                filtered.map((r) => (
                  <tr key={r.id}>
                    <td className="text-left">{r.dream}</td>
                    <td>{r.direct || "-"}</td>
                    <td>{r.house || "-"}</td>
                    <td>{r.ending || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </PublicLayout>
  );
}
